import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { FaGoogle, FaStar } from "react-icons/fa";

const GoogleReviewsQR = () => {
  const [activeTab, setActiveTab] = useState("google");

  const reviews = {
    google: {
      link: "https://g.page/r/Cb8niPP5OfTDEBM/review",
      icon: <FaGoogle className="text-white text-lg" />, 
      color: "bg-[#4285F4] hover:bg-[#357ae8]",
      text: "Leave a Google Review"
    },
    trustpilot: {
      link: "https://www.trustpilot.com/review/viptoursistanbul.com",
      icon: <FaStar className="text-white text-lg" />, 
      color: "bg-[#00B67A] hover:bg-[#009A5E]",
      text: "Leave a Trustpilot Review"
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-dvh bg-gray-100 p-6">
      <div className="p-6 shadow-lg rounded-2xl bg-white text-center w-80 border border-gray-300">
        <img src="https://viptoursistanbul.com/imgs/logo2.svg" alt="Logo" className="w-44 mx-auto mb-4" />
        <div className="flex border-b border-gray-300 mb-4">
          <button 
            className={`flex-1 px-4 py-2 text-center font-semibold ${activeTab === "google" ? "border-b-2 border-blue-500 text-blue-500" : "text-gray-600"}`} 
            onClick={() => setActiveTab("google")}>
            Google
          </button>
          <button 
            className={`flex-1 px-4 py-2 text-center font-semibold ${activeTab === "trustpilot" ? "border-b-2 border-green-500 text-green-500" : "text-gray-600"}`} 
            onClick={() => setActiveTab("trustpilot")}>
            Trustpilot
          </button>
        </div>
        <div className="flex flex-col items-center space-y-4">
          <h2 className="text-2xl font-semibold text-gray-800">Share Your Feedback</h2>
          <p className="text-gray-600">Scan the QR code or click the button below to leave a review.</p>
          <div className="p-2 border border-gray-300 rounded-md bg-white">
            <QRCodeCanvas value={reviews[activeTab].link} size={150} />
          </div>
          <button
            className={`w-full text-white px-4 py-2 rounded-lg flex items-center justify-center gap-2 ${reviews[activeTab].color}`}
            onClick={() => window.open(reviews[activeTab].link, "_blank", "noopener,noreferrer")}
          >
            {reviews[activeTab].icon} {reviews[activeTab].text}
          </button>
        </div>
      </div>
      <a className="text-[#4285F4] my-3 underline underline-offset-4" href="https://viptoursistanbul.com">Home page</a>
    </div>

  );
};

export default GoogleReviewsQR;